export const KindredMark = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 64 64" className={`kindred-mark ${className}`} aria-hidden="true" data-testid="kindred-logo-mark">
    <rect width="64" height="64" rx="14" fill="#0A1526" />
    <path
      className="mark-heart"
      d="M32 50 C32 50 16 39.6 16 28 C16 22 20 18 24.4 18 C28 18 30.6 20 32 22.8 C33.4 20 36 18 39.6 18 C44 18 48 22 48 28 C48 39.6 32 50 32 50 Z"
      fill="#C9A227"
    />
    <text
      x="32"
      y="40"
      textAnchor="middle"
      fontFamily="Georgia, 'Times New Roman', serif"
      fontStyle="italic"
      fontWeight="bold"
      fontSize="22"
      fill="#0A1526"
    >
      C
    </text>
  </svg>
);
